/* 太史慈傳・第 1 章：洛陽毀章（中平三年前後，186，由「年四十一，建安十一年卒」推算）
 * 史實：《三國志·太史慈傳》「會郡與州有隙，曲直未分，以先聞者為善。時州章已去，郡守恐後之，求可使者。慈年二十一，以選行，
 *       晨夜取道，到洛陽，詣公車門，見州吏始欲求通。慈問曰：『君欲通章邪？』……慈曰：『章題署得無誤邪？取來視之。』
 *       吏殊不知其東萊人也，因為取章。慈已先懷刀，便截敗之。吏踴躍大呼，言『人壞我章』！……『豈若默然俱出去，可以存易亡，無事俱就刑辟。』
 *       ……吏然慈言，即日俱去。慈既與出城，因遁還通郡章。州家聞之，更遣吏通章，有司以格章之故不復見理，州受其短。
 *       由是知名，而為州家所疾，恐受其禍，乃避之遼東。」
 * 流程：趕在州吏「求通」之前到公車門 → 問題署、等他取章、截敗之 → 吏大呼，衛士聞聲而來：趕在衛士到之前說服他「俱出去」→
 *       帶著州吏出東門（城裡的巡邏會盤問）→ 陪他走一段，趁他不回頭時折返 → 回公車門通郡章。
 * 這一章不動手：衛士、巡邏都是漢家的人（我方隊伍，打不到），被衛士在毀章現場逮到就輸。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel } from '../kit.ts';
import { walk, toward, cart, TSC_TROOPS } from './taishici_kit.ts';
import { MAIN, CLERK, CART, EGATE, START, GUARDHOUSE, GONGCHE } from '../maps/taishici_luoyang.ts';

const LV = 3, ASK = 26, PATROLS = [[[3700, 2800], [4200, 2800]], [[2300, 2800], [2900, 2700]]], CATCH = 110, SEE = 230, PART = 5500;

export default {
  id: 'taishici-1', map: 'taishici_luoyang', hero: 'taishici', gold: 0,
  title: '第 1 章　洛陽毀章', year: '中平三年前後（186）',
  brief: {
    quote: [
      { text: '會郡與州有隙，曲直未分，以先聞者為善。時州章已去，郡守恐後之，求可使者。', src: '《三國志·吳書·太史慈傳》' },
      { text: '慈年二十一，以選行，晨夜取道，到洛陽，詣公車門，見州吏始欲求通。', src: '《太史慈傳》' },
    ],
    text: '東萊郡和青州起了爭執，誰的奏章先送到朝廷，誰就佔理。州的奏章已經上路，郡守怕趕不上，選了二十一歲的奏曹史太史慈去洛陽。（年份由卒年推算。）',
    goals: ['趕在州吏的奏章通進去之前到公車門', '騙他取章、截敗之，再勸他一起逃', '一個人折返，通郡章'],
  },
  words: { ally: '衛士', foe: '—' },
  stars: [
    { text: '晨夜取道：州吏求通不到一半就趕到', ok: (m) => m.vars.early },
    { text: '沒被巡邏的衛士盤問', ok: (m) => !m.vars.asked2 },
    { text: '折返時沒被州吏察覺', ok: (m) => !m.vars.seen },
  ],
  steps: [
    { // 0. 晨夜取道
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.clerk = m.folk(5600, 1500, { name: '州吏', still: true, near: 1 }); V.clerk.pi = 4;
        V.cart = m.folk(5700, 1460, { name: '州吏的車', still: true, near: 1, draw: cart }); V.cart.pi = 4;
        V.req = 0;
        m.gate('gongche', GONGCHE[0], GONGCHE[1], 120, 'citygate'); // 公車門：上章的人在門外候通
        // 公車門的衛士（漢家的人：我方隊伍，打不到也不會打人）
        V.guards = [[-1, 0], [1, 0], [-1, 1], [1, 1]].map(([s, r]) => { const u = m.recruit(GUARDHOUSE[0] + s * 70, GUARDHOUSE[1] + r * 80, '公車衛士'); u.spec = TSC_TROOPS.guard; u.home = [u.x, u.y]; u.ms = 120; u.guard = true; return u; });
        V.gate = [-1, 1].map((s) => { const u = m.recruit(GONGCHE[0] + s * 170, GONGCHE[1] + 70, '公車衛士'); u.spec = TSC_TROOPS.guard; u.home = [u.x, u.y]; return u; });
        V.patrols = PATROLS.map((pts) => { const u = m.recruit(pts[0][0], pts[0][1], '巡城衛士'); u.spec = TSC_TROOPS.guard; u.ms = 110; m.patrol(u, pts); u.qT = -99; return u; });
        m.line('太史慈', '州章已經走了好幾天……晨夜取道，總要追上它。');
        m.after(4, () => m.line('提示', '州吏的車已經快到洛陽了。他到了公車門就開始「求通」，奏章一通進去就來不及了。林子裡的小徑比大路近。'));
        m.after(9, () => m.line('提示', '這一章不能動手。'));
        m.mark('gongche', GONGCHE[0], GONGCHE[1] + 120, '公車門');
        m.obj('race', '趕在州章通進去之前到公車門');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, c = V.clerk;
        if (!c.arrived) {
          c.arrived = walk(c, MAIN, 210, dt);
          V.cart.x = c.x + 120; V.cart.y = c.y + 30;
          if (c.arrived) { V.cart.x = CART[0]; V.cart.y = CART[1]; m.line('州吏', '青州刺史奏章，請通。'); }
        } else V.req += (100 / ASK) * dt;
        m.get('race').text = c.arrived ? `州吏在求通（${Math.min(100, Math.floor(V.req))}%）` : '趕在州章通進去之前到公車門';
        if (V.req >= 100) { m.lose('州章已經通進去了'); return false; }
        if (m.near(me, c.x, c.y, 200) && c.arrived) { V.early = V.req < 50; return true; }
        return false;
      },
    },
    { // 1. 問題署、截敗之
      enter(m, w) {
        const V = m.vars;
        m.done('race'); m.unmark('gongche');
        m.line('太史慈', '君欲通章邪？');
        m.after(1.5, () => m.line('州吏', '然。'));
        m.after(3, () => m.line('提示', '站在州吏身邊：問他奏章的題署。'));
        m.obj('cut', '問題署，讓他取章');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, c = V.clerk;
        if (!V.askedT) V.req += (100 / ASK) * dt * 0.5; // 說著話，求通慢下來
        if (V.req >= 100) { m.lose('州章已經通進去了'); return false; }
        if (!V.askedT) m.chanAt(me, 'ask', c.x, c.y, 180, 2, '問題署', () => { V.askedT = w.t; m.line('太史慈', '章安在？……章題署得無誤邪？取來視之。'); m.after(2, () => m.line('州吏', '（取章）在這裡，你看。')); });
        if (V.askedT && !V.held) { // 吏殊不知其東萊人也，因為取章
          const back = w.t - V.askedT > 1.2;
          if (!back) toward(c, CART[0] - 50, CART[1], 140, dt); else if (toward(c, CLERK[0], CLERK[1], 140, dt)) { V.held = true; m.get('cut').text = '截敗之'; }
        }
        if (V.held && !V.cut) m.chanAt(me, 'cut', c.x, c.y, 180, 1, '截章', () => { V.cut = true; });
        return !!V.cut;
      },
    },
    { // 2. 吏踴躍大呼：趕在衛士到之前說服他
      enter(m, w) {
        const V = m.vars;
        m.done('cut');
        m.card('慈已先懷刀，便截敗之。吏踴躍大呼，言「人壞我章」！', '《太史慈傳》');
        m.line('州吏', '人壞我章！人壞我章！');
        for (const u of V.guards) { u.home = [CLERK[0] - 60, CLERK[1]]; }
        m.after(1.5, () => m.line('公車衛士', '公車門前誰在喧嘩？'));
        m.after(3, () => m.line('提示', '衛士聞聲走過來了。站在州吏身邊說服他（被打斷要重來），衛士到之前要走。'));
        m.obj('talk', '說服州吏「默然俱出去」');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, c = V.clerk;
        m.chanAt(me, 'talk', c.x, c.y, 180, 4, '與語', () => { V.agreed = true; });
        return !!V.agreed;
      },
    },
    { // 3. 俱出去：帶州吏出東門
      enter(m, w) {
        const V = m.vars;
        m.done('talk');
        m.line('太史慈', '向使君不以章相與，吾亦無因得敗之，是為吉凶禍福等耳，吾不獨受此罪。豈若默然俱出去？');
        m.after(3, () => m.line('州吏', '君為郡敗吾章，已得如意，欲復亡為？'));
        m.after(6, () => m.line('太史慈', '吾用意太過，乃相敗章。今還，亦恐以此見譴怒，故俱欲去爾。'));
        m.after(9, () => m.line('州吏', '……也罷，一起走。'));
        V.guardsT = w.t;
        m.mark('egate', EGATE[0] + 200, EGATE[1], '東城門');
        m.obj('out', '帶州吏出東城門');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, c = V.clerk;
        toward(c, me.x - 70 * (me.f || 1), me.y + 40, 320, dt, 30);
        if (w.t - V.guardsT > 6) for (const u of V.guards) u.home = [GUARDHOUSE[0], GUARDHOUSE[1]]; // 找不到人，回廬舍
        return me.x > EGATE[0] + 250 && SG.gd(c.x, c.y, me.x, me.y) < 450;
      },
    },
    { // 4. 慈既與出城，因遁還
      enter(m, w) {
        const V = m.vars;
        m.done('out'); m.unmark('egate');
        V.left = true; V.c0 = w.t;
        m.card('吏然慈言，即日俱去。', '《太史慈傳》');
        m.after(3, () => m.line('提示', `陪州吏往東走一段，再趁他沒回頭的時候折返（他一陣子回頭看一次，被看見就穿幫）。`));
        m.obj('slip', '陪州吏走一段，再悄悄折返');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, c = V.clerk, d = SG.gd(c.x, c.y, me.x, me.y);
        if (!V.free) {
          if (d < 450) toward(c, START[0], START[1], 90, dt); else c.walk = false; // 走遠了就等他
          if (c.x >= PART) { V.free = true; V.lookT = w.t + 2.5; m.line('州吏', '……'); m.get('slip').text = '趁州吏沒回頭，折返公車門'; m.mark('gongche', GONGCHE[0], GONGCHE[1] + 120, '公車門'); }
          return false;
        }
        toward(c, START[0], START[1], 90, dt);
        // 回頭：每 6 秒回頭 1.2 秒
        const ph = (w.t - V.lookT) % 6;
        c.looking = w.t >= V.lookT && ph < 1.2;
        if (c.looking) { c.f = -1; c.walk = false; }
        const back = me.x < (V.px == null ? me.x : V.px) - 0.5; // 正在往回走
        V.px = me.x;
        if (c.looking && !V.seen && back && d > 250 && d < 900) { V.seen = true; m.line('州吏', '子義？你往回走做什麼？……'); m.after(2, () => m.line('太史慈', '（佯裝解手）就來。')); }
        return me.x < EGATE[0] - 100;
      },
    },
    { // 5. 通郡章
      enter(m) {
        m.done('slip');
        m.line('太史慈', '郡章在此。');
        m.obj('tong', '回公車門通郡章');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'tong', CLERK[0], CLERK[1], 200, 3, '通郡章', () => { V.tong = true; });
        if (!V.tong) return false;
        m.done('tong'); m.unmark('gongche');
        m.card('慈既與出城，因遁還通郡章。州家聞之，更遣吏通章，有司以格章之故不復見理，州受其短。', '《太史慈傳》');
        m.after(5, () => m.card('由是知名，而為州家所疾，恐受其禍，乃避之遼東。', '《太史慈傳》'));
        m.after(10, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('太史慈遇害'); return; }
    // 毀章之後、出城之前：衛士在現場逮到人就輸
    if (m.i === 2 || (m.i === 3 && w.t - V.guardsT < 6)) for (const u of V.guards) if (SG.gd(u.x, u.y, me.x, me.y) < CATCH && SG.gd(me.x, me.y, CLERK[0], CLERK[1]) < 600) { m.lose('毀章的現場被公車衛士拿下'); return; }
    // 巡城衛士：靠得太近就盤問（停下來應對三秒）
    for (const u of V.patrols || []) if (u.alive && w.t - u.qT > 10 && SG.gd(u.x, u.y, me.x, me.y) < SEE && m.i >= 3) {
      u.qT = w.t; V.asked2 = true;
      w.addBuff(me, { id: '盤問', t: 3, neg: true, ms: -0.95 });
      m.line('巡城衛士', '站住！何處人？往哪裡去？');
      m.after(1.5, () => m.line('太史慈', '東萊郡吏，送人出城。'));
    }
  },
  // 巡城衛士看得到的範圍
  ground(ctx, m) {
    for (const u of m.vars.patrols || []) { ctx.fillStyle = 'rgba(200,60,40,.10)'; ctx.strokeStyle = 'rgba(200,60,40,.35)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.ellipse(u.x, u.y, SEE, SEE * SG.K, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); }
    const c = m.vars.clerk;
    if (c && c.looking) { ctx.fillStyle = 'rgba(255,212,107,.12)'; ctx.beginPath(); ctx.ellipse(c.x, c.y, 900, 900 * SG.K, 0, 0, Math.PI * 2); ctx.fill(); }
  },
};
